// removed by extract-text-webpack-plugin
module.exports = {"container":"ofU4LJSFzBclzxiipSxer","market":"_3I98GSp-zpxp4xA4b6ij4a"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Exchange/Layout/Navbar/Markets/Menu/List/Markets/Mobile/styles.css
// module id = 1608
// module chunks = 83